import requests from '@/utils/requests';

/**
 * 提审通过率
 * @param {*} data
 */
export function releasePassedRate(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/releasePassedRate',
    method: 'post',
    data
  });
}

/**
 * 提审通过率
 * @param {*} data
 */
export function accurateWorkflowAnalysis(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/diagram/accurateWorkflowAnalysis',
    method: 'post',
    data
  });
}

/**
 * 提审通过率
 * @param {*} data
 */
export function accurateUseAnalysis(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/diagram/accurateUseAnalysis',
    method: 'post',
    data
  });
}

/**
 * 检查需求提审条件
 * @param {*} data
 */
export function checkReqEnable(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/workflow/checkReqEnable',
    method: 'post',
    data
  });
}
